export const PROVIDER_PURCHASE_ORDER_DOCUMENTS = [
  {
    key: "commercialInvoice",
    label: "Factura Comercial",
  },
  {
    key: "packingList",
    label: "Lista de Empaque",
  },
  {
    key: "certificateOrigin",
    label: "Certificado de Origen",
  },
  {
    key: "certificateWarranty",
    label: "Certificado de Garantia",
  },
  {
    key: "qualityTestsA",
    label: "Pruebas de Calidad",
  },
  {
    key: "qualityCertificate",
    label: "Certificado de Calidad",
  },

  {
    key: "technicalDataSheet",
    label: "Hoja de Datos Técnicos",
  },
  {
    key: "blAwb",
    label: "BL/AWB",
  },
];

export const DEFAULT_PROVIDER_PURCHASE_ORDER_DOCUMENT_CHECKS =
  PROVIDER_PURCHASE_ORDER_DOCUMENTS.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});